<template>
  <!-- <h1>{{ event.current_locale }}</h1> -->
  <div
    class="event-item"
    :class="[
      `event-item-${eventItem.id ? eventItem.id : 'draft'}`,
      event.current_locale === 'en' ? 'en-class' : 'he-class',
    ]"
  >
    <!-- <div
      class="new"
      :class="event.current_locale === 'en' ? 'en-class' : 'he-class'"
    > -->
    <div class="event-item-inner" :class="{ highlight: highlight }">
      <div
        class="event-thumbnail"
        :style="{ backgroundImage: `url(${eventItem.image})` }"
      ></div>
      <div class="event-meta">
        <div class="event-titles">
          <div class="event-name">{{ eventItem.name }}</div>
          <div class="event-speaker">
            {{ eventItem.speaker_name }}
          </div>
        </div>
        <a 
                    :href="signupsUrl" 
                    target="_blank" 
                    class="event-views"
                    style="text-decoration: none; cursor: pointer;"
                >
          <span class="views-icon"></span>
          <span class="views-text">{{ eventItem.signup_count }}</span>
        </a>
      </div>
      <div class="event-body">
        <div v-if="!draft" class="event-links">
          <a
            target="_blank"
            :href="eventItem.link"
            class="event-outer-link"
          ></a>
          <a
            @click.prevent="copyLink(eventItem.link)"
            target="_blank"
            :href="eventItem.link"
            class="event-copy-link"
          ></a>
        </div>
        <!-- <div class="event-items-list">
          <div v-if="eventItem.date" class="event-list-item">
            <div class="list-item-title">
              {{ $trans("event.manage.date") }}
            </div>
            <div class="list-item-value">{{ eventItem.date }}</div>
          </div>
          <div v-if="eventItem.time" class="event-list-item">
            <div class="list-item-title">
              {{ $trans("event.manage.time") }}
            </div>
            <div class="list-item-value">{{ eventItem.time }}</div>
          </div>
          <div
            v-if="eventItem.is_online || eventItem.location"
            class="event-list-item"
          >
            <div class="list-item-title">
              {{ $trans("event.manage.location") }}
            </div>
            <div class="list-item-value">
              {{
                eventItem.is_online
                  ? $trans("event.manage.online")
                  : eventItem.location
              }}
            </div>
          </div>
        </div> -->
      </div>
      <div class="event-footer" :class="{ draft: draft }">
        <a
          v-if="!draft"
          @click.prevent="duplicateEvent"
          class="duplicate"
          style="width: 33.33%"
          :class="{ loading: duplicating }"
          href="#"
        >
          <app-loader v-if="duplicating"></app-loader>
          <span v-if="!duplicating" style="display: flex"
            >{{ $trans("event.manage.duplicate") }}
            <img src="../../../../images/icons/copy.svg" style="height: 19px"
          /></span>
        </a>
        <a
          class="edit"
          :href="editEventUrl"
          style="display: flex; gap: 12px; width: 33.33%"
          >{{ $trans("event.manage.edit") }}
          <img src="../../../../images/icons/details.svg" style="height: 22px"
        /></a>
        <a
          @click.prevent="deleteEvent"
          class="delete"
          style="width: 33.33%"
          :class="{ loading: deleting }"
          href="#"
        >
          <app-loader v-if="deleting"></app-loader>
          <span v-if="!deleting" style="display: flex; gap: 4px"
            >{{ $trans("event.manage.delete") }}
            <img src="../../../../images/icons/closee.svg"
          /></span>
        </a>
        <span v-if="draft" class="event-draft-title">{{
          $trans("event.manage.in_draft")
        }}</span>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  emits: ["duplicate", "delete"],
  props: {
    eventItem: {
      type: Object,
    },
    draft: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      event: window.app.event,
      duplicating: false,
      deleting: false,
    };
  },

  mounted() {
    // console.log("eventtttt", this.event);
  },
  computed: {
    editEventUrl() {
      if (this.draft) {
        return (
          this.event.create.toString().replace("%id%", this.eventItem.id) + "/1"
        );
      }

            return this.event.create
                .toString()
                .replace("%id%", this.eventItem.id);
        },
        signupsUrl() {
            return `/table/${this.eventItem.id}/signups`;
        }
    },
    methods: {
        setClipboardText(text) {
            var id = "mycustom-clipboard-textarea-hidden-id";
            var existsTextarea = document.getElementById(id);

      if (!existsTextarea) {
        // console.log("Creating textarea");
        var textarea = document.createElement("textarea");
        textarea.id = id;
        // Place in top-left corner of screen regardless of scroll position.
        textarea.style.position = "fixed";
        textarea.style.top = 0;
        textarea.style.left = 0;

        // Ensure it has a small width and height. Setting to 1px / 1em
        // doesn't work as this gives a negative w/h on some browsers.
        textarea.style.width = "1px";
        textarea.style.height = "1px";

        // We don't need padding, reducing the size if it does flash render.
        textarea.style.padding = 0;

        // Clean up any borders.
        textarea.style.border = "none";
        textarea.style.outline = "none";
        textarea.style.boxShadow = "none";

        // Avoid flash of white box if rendered for any reason.
        textarea.style.background = "transparent";
        document.querySelector("body").appendChild(textarea);
        existsTextarea = document.getElementById(id);
      }

      existsTextarea.value = text;
      existsTextarea.select();

      try {
        document.execCommand("copy");
      } catch (err) {}
    },

    async generateBitlyAccessToken() {
      // console.log("____________________________________");
      const clientId = "b971f1018786b7e9c7c6f0c10be8e19ee268e1bd"; // Replace with your actual client ID
      const clientSecret = "02e63da780680686d8237ce22dc6e629ea02d624"; // Replace with your actual client secret
      const username = "dhwanisurati.dds@gmail.com"; // Replace with your actual Bitly email
      const password = "dhwani2023"; // Replace with your actual Bitly password

      try {
        const response = await fetch(
          "https://api-ssl.bitly.com/oauth/access_token",
          {
            method: "POST",
            headers: {
              Authorization: "Basic " + btoa(`${clientId}:${clientSecret}`),
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              grant_type: "password",
              username: username,
              password: password,
            }),
          }
        );
        console.log("responseresponse", response);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        console.log("Access Token:", data.access_token);
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error.message
        );
      }
    },

    async copyLink(link) {
      console.log("GG");
      console.log("link", link);

      try {
        const response = await axios.post(
          "https://api.rebrandly.com/v1/links",
          {
            destination: link,
            domain: { fullName: "rebrand.ly" }, // Customize the domain if needed
          },
          {
            headers: {
              "Content-Type": "application/json",
              apikey: "90715d0ed1df4c48953a899f928d98e5", // Replace with your actual Rebrandly API key
            },
          }
        );
        console.log("response", response);
        // this.shortUrl = response.data.shortUrl;
      } catch (error) {
        console.error("Error shortening URL:", error);
      }

      this.setClipboardText(link);
      // fetch('https://api-ssl.bitly.com/v4/shorten', {
      //     method: 'POST',
      //     headers: {
      //         'Content-Type': 'application/json',
      //         'Authorization': 'Bearer YOUR_ACCESS_TOKEN'
      //     },
      //     body: JSON.stringify({
      //         long_url: link
      //     })
      // })
      //     .then(response => response.json())
      //     .then(data => {
      //         console.log(`Shortened URL: ${data.link}`);
      //     })
      //     .catch(error => console.error('Error:', error));
      this.$swal({
        position: "top",
        title: this.$trans("event.create.link_copied"),
        showConfirmButton: false,
        timer: 2000,
      });
    },
    async duplicateEvent() {
      if (this.duplicating) {
        return;
      }

      this.duplicating = true;

      let response;

      try {
        response = await this.$api.post(`event/duplicate/${this.eventItem.id}`);
      } catch (e) {
        return;
      }

      if (!response.hasErrors()) {
        window.location.href = `${this.event.manage_events}?highlight=${
          response.data().event.id
        }`;
      }
    },
    async deleteEvent() {
      if (this.deleting) {
        return;
      }

      this.deleting = true;

      let response;

      try {
        let deleteUrl = `event/delete/${this.eventItem.id}`;

        if (this.draft) {
          deleteUrl += "/1";
        }

        response = await this.$api.post(deleteUrl);
      } catch (e) {
        return;
      }

      if (!response.hasErrors()) {
        window.location.reload();
      }
    },
  },
};
</script>

<style>
.en-class .event-item-inner .event-footer a.edit,
a.delete {
  background-position: calc(100% - 10px) center;
  background-size: 17px;
}
.he-class a.edit {
  background-position: left 12px center;
  background-size: 17px;
}

.en-class .event-item-inner .event-footer a.duplicate {
  background-position: calc(100% - 10px) center;
  background-size: 17px;
}
.he-class a.duplicate {
  background-position: left 12px center;
  background-size: 17px;
}

.en-class .event-item-inner .event-footer a.delete {
  background-position: calc(100% - 10px) center;
  background-size: 17px;
}
.he-class a.delete {
  background-position: left 12px center;
  background-size: 17px;
}
</style>


